// Mock 用户数据
export const mockUsers = [
  {
    id: 1,
    username: 'admin',
    password: '123456',
    nickname: '超级管理员',
    avatar: '',
    email: 'admin@example.com',
    phone: '13800138000',
    status: 1,
    roleIds: [1],
    roles: ['admin'],
    createTime: '2024-01-01 00:00:00',
  },
  {
    id: 2,
    username: 'editor',
    password: '123456',
    nickname: '编辑员',
    avatar: '',
    email: 'editor@example.com',
    phone: '13800138001',
    status: 1,
    roleIds: [2],
    roles: ['editor'],
    createTime: '2024-01-02 00:00:00',
  },
  {
    id: 3,
    username: 'viewer',
    password: '123456',
    nickname: '访客',
    avatar: '',
    email: 'viewer@example.com',
    phone: '13800138002',
    status: 0,
    roleIds: [3],
    roles: ['viewer'],
    createTime: '2024-01-03 00:00:00',
  },
]

// Mock 角色数据
export const mockRoles = [
  {
    id: 1,
    name: '超级管理员',
    code: 'admin',
    description: '拥有所有权限',
    status: 1,
    menuIds: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 15, 16, 17, 18],
    createTime: '2024-01-01 00:00:00',
  },
  {
    id: 2,
    name: '编辑员',
    code: 'editor',
    description: '拥有内容编辑权限',
    status: 1,
    menuIds: [2, 5, 9, 15, 16, 17, 18],
    createTime: '2024-01-02 00:00:00',
  },
  {
    id: 3,
    name: '访客',
    code: 'viewer',
    description: '只有查看权限',
    status: 1,
    menuIds: [2, 5],
    createTime: '2024-01-03 00:00:00',
  },
]

// Mock 菜单数据（树形）
export const mockMenus = [

  {
    id: 15,
    parentId: 0,
    name: '我的店铺',
    type: 1,
    icon: 'Shop',
    path: '/shop',
    component: 'shop/index',
    permission: '',
    sort: 0,
    status: 1,
    children: [],
  },
  {
    id: 18,
    parentId: 0,
    name: '订单管理',
    type: 1,
    icon: 'List',
    path: '/order',
    component: 'order/index',
    permission: '',
    sort: 0,
    status: 1,
    children: [],
  },
  {
    id: 17,
    parentId: 0,
    name: '商品库',
    type: 1,
    icon: 'Goods',
    path: '/goods',
    component: 'goods/index',
    permission: '',
    sort: 0,
    status: 1,
    children: [],
  },
  {
    id: 16,
    parentId: 0,
    name: '资金中心',
    type: 1,
    icon: 'Coin',
    path: '/finance',
    component: 'finance/index',
    permission: '',
    sort: 0,
    status: 1,
    children: [],
  },
  
  
  // {
  //   id: 2,
  //   parentId: 0,
  //   name: '系统管理',
  //   type: 1,
  //   icon: 'Setting',
  //   path: '/system',
  //   component: '',
  //   permission: '',
  //   sort: 2,
  //   status: 1,
  //   children: [
  //     {
  //       id: 3,
  //       parentId: 2,
  //       name: '用户管理',
  //       type: 1,
  //       icon: 'User',
  //       path: '/system/user',
  //       component: 'system/user/index',
  //       permission: 'system:user:list',
  //       sort: 1,
  //       status: 1,
  //       children: [
  //         { id: 6, parentId: 3, name: '新增用户', type: 2, icon: '', path: '', component: '', permission: 'system:user:add', sort: 1, status: 1, children: [] },
  //         { id: 7, parentId: 3, name: '编辑用户', type: 2, icon: '', path: '', component: '', permission: 'system:user:edit', sort: 2, status: 1, children: [] },
  //         { id: 8, parentId: 3, name: '删除用户', type: 2, icon: '', path: '', component: '', permission: 'system:user:delete', sort: 3, status: 1, children: [] },
  //       ],
  //     },
  //     {
  //       id: 4,
  //       parentId: 2,
  //       name: '角色管理',
  //       type: 1,
  //       icon: 'Avatar',
  //       path: '/system/role',
  //       component: 'system/role/index',
  //       permission: 'system:role:list',
  //       sort: 2,
  //       status: 1,
  //       children: [
  //         { id: 9, parentId: 4, name: '新增角色', type: 2, icon: '', path: '', component: '', permission: 'system:role:add', sort: 1, status: 1, children: [] },
  //         { id: 10, parentId: 4, name: '编辑角色', type: 2, icon: '', path: '', component: '', permission: 'system:role:edit', sort: 2, status: 1, children: [] },
  //         { id: 11, parentId: 4, name: '删除角色', type: 2, icon: '', path: '', component: '', permission: 'system:role:delete', sort: 3, status: 1, children: [] },
  //       ],
  //     },
  //     {
  //       id: 5,
  //       parentId: 2,
  //       name: '菜单管理',
  //       type: 1,
  //       icon: 'Menu',
  //       path: '/system/menu',
  //       component: 'system/menu/index',
  //       permission: 'system:menu:list',
  //       sort: 3,
  //       status: 1,
  //       children: [
  //         { id: 12, parentId: 5, name: '新增菜单', type: 2, icon: '', path: '', component: '', permission: 'system:menu:add', sort: 1, status: 1, children: [] },
  //         { id: 13, parentId: 5, name: '编辑菜单', type: 2, icon: '', path: '', component: '', permission: 'system:menu:edit', sort: 2, status: 1, children: [] },
  //         { id: 14, parentId: 5, name: '删除菜单', type: 2, icon: '', path: '', component: '', permission: 'system:menu:delete', sort: 3, status: 1, children: [] },
  //       ],
  //     },
  //   ],
  // },
]

// 权限列表 (admin 用户)
export const adminPermissions = [
  'system:user:list', 'system:user:add', 'system:user:edit', 'system:user:delete',
  'system:role:list', 'system:role:add', 'system:role:edit', 'system:role:delete',
  'system:menu:list', 'system:menu:add', 'system:menu:edit', 'system:menu:delete',
]

export const editorPermissions = [
  'system:user:list', 'system:role:list', 'system:menu:list',
]

export const viewerPermissions = [
  'system:user:list',
]
